// extracted by mini-css-extract-plugin
export var cancelButton = "_qw-5";
export var content = "_qw-3";
export var createButton = "_qw-6";
export var drawerContainer = "_qw-0";
export var footer = "_qw-2";
export var header = "_qw-1";
export var orderFormColumn = "_qw-4";